import React from "react";

export default function ShoppingCartIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.05666 21.004C10.1305 21.004 11.001 20.1334 11.001 19.0596C11.001 17.9858 10.1305 17.1152 9.05666 17.1152C7.98282 17.1152 7.1123 17.9858 7.1123 19.0596C7.1123 20.1334 7.98282 21.004 9.05666 21.004Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M17.5283 21.004C18.6022 21.004 19.4727 20.1334 19.4727 19.0596C19.4727 17.9858 18.6022 17.1152 17.5283 17.1152C16.4545 17.1152 15.584 17.9858 15.584 19.0596C15.584 20.1334 16.4545 21.004 17.5283 21.004Z'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.55037 3.63477L6.84793 10.9093C7.20114 12.0272 7.37717 12.5861 7.71666 12.9999C8.01386 13.3657 8.40136 13.648 8.83916 13.8229C9.33639 14.0207 9.92164 14.0207 11.0944 14.0207H15.501C16.6737 14.0207 17.259 14.0207 17.7551 13.8229C18.194 13.648 18.5804 13.3657 18.8787 12.9999C19.2171 12.5861 19.3931 12.0272 19.7474 10.9093L20.215 9.42784L20.4893 8.55225L20.8677 7.35203C21.0027 6.92395 21.035 6.47008 20.9619 6.02721C20.8888 5.58433 20.7124 5.1649 20.447 4.80289C20.1817 4.44088 19.8347 4.14647 19.4344 3.94353C19.034 3.74059 18.5914 3.63481 18.1426 3.63477H4.55037ZM4.55037 3.63477L4.53779 3.59248C4.48953 3.4308 4.43616 3.27069 4.37776 3.11239C4.14635 2.52661 3.75392 2.01827 3.24581 1.64609C2.73771 1.27391 2.13467 1.05309 1.50638 1.00914C1.38864 1 1.25948 1 1 1'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
